import React from 'react';
import FoundationLayout from '../components/layout/FoundationLayout';
import TheoryPage from '../components/IITTheory/TheoryPage';
import { getFoundationStudent } from '../foundationSession';

/**
 * IIT Foundation Theory — the textbook theory for the logged-in student's class.
 * The class comes from the in-memory session (grade_id → f_class.id); the
 * subject tabs come from whatever theory exists for that class.
 */
const IITFoundationTheory = () => {
    const student = getFoundationStudent() || {};

    return (
        <FoundationLayout student={student}>
            <TheoryPage
                classId={student.grade_id != null ? student.grade_id : null}
                classValue={student.class_num || "10"}
            />
        </FoundationLayout>
    );
};

export default IITFoundationTheory;
